import { styled } from 'storybook/internal/theming';

export const InspectorContainer = styled.div({
  flex: 1,
  padding: '0 0 0 5px',
});
